var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyRobot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 151c41.421 0 75-33.579 75-75S117.421 1 76 1 1 34.579 1 76s33.579 75 75 75z",
    fill: "#fff",
    stroke: "#E4E7EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "w5746ei6ra",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 150,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 151c41.421 0 75-33.579 75-75S117.421 1 76 1 1 34.579 1 76s33.579 75 75 75z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#7uvjjgc54b)",
    mask: "url(#w5746ei6ra)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.117 49.78A33.406 33.406 0 0 0 76.5 40H38.458A3.456 3.456 0 0 0 35 43.457v111.086A3.456 3.456 0 0 0 38.458 158h76.084a3.456 3.456 0 0 0 3.458-3.457V67.656L100.117 49.78z",
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.334,
    d: "M118 154.543V67.656L90.333 40H76.5v118h38.042a3.456 3.456 0 0 0 3.458-3.457z",
    fill: "#D5E8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.989 61.755-20.75-20.742A3.456 3.456 0 0 0 93.794 40h-3.458v24.2a3.458 3.458 0 0 0 3.458 3.456h24.209V64.2c0-.918-.365-1.796-1.014-2.444z",
    fill: "#6EA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "M66.5 130h-14a3.498 3.498 0 0 1-3.5-3.5v-21c0-1.935 1.565-3.5 3.5-3.5h14c1.935 0 3.5 1.565 3.5 3.5v21c0 1.935-1.565 3.5-3.5 3.5z",
    fill: "#A8C9F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "M100.5 144h-21c-1.935 0-3.5-1.528-3.5-3.417v-34.166c0-1.889 1.565-3.417 3.5-3.417h21c1.935 0 3.5 1.528 3.5 3.417v34.166c0 1.889-1.565 3.417-3.5 3.417z",
    fill: "#619DEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "M66.5 144h-14a3.498 3.498 0 0 1-3.5-3.5c0-1.935 1.565-3.5 3.5-3.5h14c1.935 0 3.5 1.565 3.5 3.5s-1.565 3.5-3.5 3.5zM100.562 74H52.437C50.538 74 49 75.548 49 77.462v14.076C49 93.453 50.538 95 52.438 95h48.124c1.901 0 3.438-1.548 3.438-3.462V77.463c0-1.914-1.537-3.462-3.438-3.462z",
    fill: "#A8C9F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "M104 91.538V77.463c0-1.914-1.565-3.462-3.5-3.462H76v21h24.5c1.935 0 3.5-1.548 3.5-3.462z",
    fill: "#619DEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "7uvjjgc54b",
    x: 25,
    y: 32,
    width: 103,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.961921 0 0 0 0 0.961921 0 0 0 0 0.961921 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_346_181929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_346_181929",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRobot);
export default __webpack_public_path__ + "static/media/emptyRobot.f77394a5.svg";
export { ForwardRef as ReactComponent };